/**
 * Badge Component
 * Displays small pill-shaped labels for tags, categories, status, etc.
 * Supports multiple variants and custom styling
 */

import PropTypes from 'prop-types';

const VARIANT_STYLES = {
  primary: 'bg-brand-100 text-brand-700 border-brand-200',
  secondary: 'bg-neutral-100 text-neutral-700 border-neutral-200',
  success: 'bg-success-100 text-success-700 border-success-200',
  warning: 'bg-warning-100 text-warning-700 border-warning-200',
  error: 'bg-error-100 text-error-700 border-error-200',
  info: 'bg-blue-100 text-blue-700 border-blue-200'
};

export default function Badge({ children, variant = 'secondary', className = '', ...props }) {
  const variantClasses = VARIANT_STYLES[variant] || VARIANT_STYLES.secondary;

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${variantClasses} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

Badge.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error', 'info']),
  className: PropTypes.string
};
